(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PublisherIbqDetailController', PublisherIbqDetailController);

    PublisherIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Publisher', 'Material'];

    function PublisherIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Publisher, Material) {
        var vm = this;

        vm.publisher = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:publisherUpdate', function(event, result) {
            vm.publisher = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
